var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-logo tw-flex tw-h-full"},[_c('default-header-logo-iu',{staticClass:"iu-logo tw-h-full"}),_c('v-img',{staticClass:"tw-ml-4",attrs:{"src":"https://igws.indiana.edu/images/IGWS_Logo.svg","max-width":"140","contain":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }